/**
 * ヘッダーナビゲーション制御用モジュール
 *
 * - HeaderNav: スマホ用ナビゲーションの開閉や子メニューのトグルを管理
 * - NavCurrentHighlight: 現在ページに応じてナビゲーションのハイライトを自動付与
 *
 * @example
 *   const nav = new HeaderNav();
 *   nav.init();
 *
 *   const highlighter = new NavCurrentHighlight();
 *   highlighter.init();
 *
 * 注意:
 * - HTML構造やID/クラス名が変わる場合はセレクタも要調整
 * - アクセシビリティ向上のため、tabindex制御も実装
 */
export class HeaderNav {
	constructor() {
		this.switchLinks = document.querySelectorAll('#switchBtnArea a');
		this.spNav = document.getElementById('spNav');
		this.switchBtn = document.getElementById('switchBtn');
		this.childTriggers = document.querySelectorAll('#spNav .has-child span');
	}

	init() {
		if (!this.switchLinks.length || !this.spNav) return;
		this.bindEvents();
	}

	bindEvents() {
		this.switchLinks.forEach((el) => {
			el.addEventListener('click', () => this.toggleNav());
		});
		this.childTriggers.forEach((el) => {
			el.addEventListener('click', (e) => this.toggleChild(e.target));
		});
	}

	toggleNav() {
		const isVisible = this.spNav.style.display === 'block';
		this.spNav.style.display = isVisible ? 'none' : 'block';
		/**
		 * 初期化処理。必要な要素が揃っていればイベントバインド。
		 */
		this.switchBtn.classList.toggle('btnClose');
	}

	toggleChild(el) {
		const next = el.nextElementSibling;
		/**
		 * イベントリスナー登録（ナビ開閉・子メニュー開閉）
		 */
		if (!next) return;
		const isVisible = next.style.display === 'block';
		next.style.display = isVisible ? 'none' : 'block';
		el.classList.toggle('open');
	}
}

/**
 * ナビゲーションの現在地ハイライト制御
 *
 * - data-dir属性にカンマ区切りで複数ディレクトリ指定可
 * - ルート判定や部分一致で自動的にハイライト
 */
export class NavCurrentHighlight {
	constructor({
		/**
		 * スマホナビの開閉トグル
		 */
		selector = '.js-nav-link',
		dataAttr = 'data-dir',
		activeClass = 'has-current',
	} = {}) {
		this.items = document.querySelectorAll(selector);
		this.dataAttr = dataAttr;
		/**
		 * 子メニューの開閉トグル
		 * @param {Element} el トリガー要素
		 */
		this.activeClass = activeClass;
		this.currentPath = location.pathname;
	}

	init() {
		this.items.forEach((item) => {
			const dirRaw = item.getAttribute(this.dataAttr);
			if (!dirRaw) return;

			// カンマ区切りで複数対応
			let dirs = dirRaw
				.split(',')
				.map((d) => d.trim())
				.filter(Boolean);

			// 1) ルート判定 "/" が含まれる場合
			const hasRoot = dirs.includes('/');

			if (hasRoot) {
				// ルート用の特別処理
				if (
					/**
					 * 各ナビリンクに対し、現在地に応じてハイライト付与
					 */
					this.currentPath === '/tdec/recruit/' ||
					this.currentPath === '/tdec/recruit/index_j.html'
				) {
					item.classList.add(this.activeClass);
					item.querySelector(':scope > a')?.setAttribute('tabindex', '-1');
				}
				// 通常判定に使わないように除外する
				dirs = dirs.filter((d) => d !== '/');
			}

			// 2) 通常のマッチ（"/" は除外済み）
			if (dirs.length > 0) {
				const matched = dirs.some((dir) => this.currentPath.includes(dir));
				if (matched) {
					item.classList.add(this.activeClass);
					item.querySelector(':scope > a')?.setAttribute('tabindex', '-1');
				}
			}
		});
	}
}
